export default {
  personalData: 'personalData',
  address: 'address',
  identificationDocument: 'identificationDocument',
  academicFormation: 'academicFormation',
  financialSponsor: {
    personalData: 'financialSponsor.personalData',
    identificationDocument: 'financialSponsor.identificationDocument',
    address: 'financialSponsor.address',
  },
  documents: 'documents',
  contract: 'contract',
  payment: 'payment',
  failPayment: 'failPayment',
  success: 'success',
  pendingPayment: 'pendingPayment',
  accounts: 'accounts',
  accountsResult: 'accountsResult',
};
